import history from './history';

const NavigationService = (path, replaceHistory) => (replaceHistory ? history.replace(path) : history.push(path));

export default NavigationService;
